// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"ButtonsWrapper__buttonsWrapper___13uiE","alignRight":"ButtonsWrapper__alignRight___1_Yb7"};